<template>
	<div>
		<VueSlickCarousel v-bind="settings">
			<slot name="slideContents"></slot>
		</VueSlickCarousel>
	</div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
	components: {
		VueSlickCarousel,
	},
	props: {
		settings: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
